import {
  funcScrollControl,
  funcLoad,
} from './index';

const funcEntry = (() => {


  // funcScrollControl.noScroll();


  if (document.querySelector("body#pageTop") !== null) {
    document.addEventListener("DOMContentLoaded", () => {
      funcLoad()
    });
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      funcLoad()
    });
  }


})();
export default funcEntry;